/**
 * Firestore Collection Names
 *
 * Centralized collection name constants to avoid magic strings
 * and enable easier refactoring of collection structure.
 */

export const COLLECTIONS = {
  posts: 'posts',
  tags: 'tags',
  contacts: 'contacts',
  auditLogs: 'auditLogs',
  rateLimits: 'rateLimits',
  editors: 'editors',
  media: 'media',
} as const;

export type CollectionName = (typeof COLLECTIONS)[keyof typeof COLLECTIONS];

/**
 * Firestore subcollection paths
 */
export const SUBCOLLECTIONS = {
  // Future subcollections can be added here
} as const;

/**
 * Get full collection path
 * @param collection - Collection name
 * @param documentId - Optional document ID for subcollection paths
 */
export function getCollectionPath(
  collection: CollectionName,
  documentId?: string
): string {
  if (documentId) {
    return `${collection}/${documentId}`;
  }
  return collection;
}
